<template>
  <div class="main partner">
    <div class="head">
      <span style="margin-bottom: 0.3rem">智慧伊旗农牧大数据平台</span>
    </div>
    <div class="section">
      <div class="gobcak" @click="goBack"><img src="../../../../assets/yq/yiqi_back.png" alt="" /><span>返回上一层</span></div>
      <div class="box">
        <div class="box-item">
          <div class="top-l">
            <chartTitle title="养殖活畜分析"></chartTitle>

            <div class="plant_centent">
              <div class="center">
                <div class="num">
                  <div class="title">养殖活畜总数(头)</div>
                  <div class="card">
                    <div class="card-num">3</div>
                    <div class="card-num">5</div>
                    <div class="card-num">7</div>
                    <div class="card-num">6</div>
                  </div>
                </div>
                <div class="pie" id="areaChart"></div>
                <div class="map-font">
                  <div class="font-box" v-for="(item, index) in piedata1" :key="index">
                    <div class="radio" :style="{ backgroundColor: item.color }"></div>
                    <div>{{ item.name }}</div>
                    <div>{{ item.total }}%</div>
                    <div>{{ item.value }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="warrning">
            <chartTitle title="活畜品种占比" :optionsList="typeList"></chartTitle>

            <!-- .warrning_icon_1.png -->
            <div class="warrning_content">
              <div class="center">
                <div class="num">
                  <div class="title">牛只总量(头)</div>
                  <div class="card">
                    <div class="card-num">3</div>
                    <div class="card-num">5</div>
                    <div class="card-num">7</div>
                    <div class="card-num">6</div>
                    <div class="card-num">6</div>
                  </div>
                </div>
                <div class="pie" id="numPieChart"></div>
                <div class="map-font">
                  <div class="font-box" v-for="(item, index) in piedata2" :key="index">
                    <div class="radio" :style="{ backgroundColor: item.color }"></div>
                    <div>{{ item.name }}</div>
                    <div>{{ item.total }}%</div>
                    <div>{{ item.value }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box-center">
          <!-- <div class="tips">
            <div class="env">
              <div><img src="../../../assets/yq/device_icon_3.png" alt="" srcset="" /></div>
              <div>
                <label>环境检测设备</label>
                <span>8769</span>
              </div>
            </div>
            <div class="env">
              <div><img src="../../../assets/yq/device_icon_4.png" alt="" srcset="" /></div>
              <div class="env-text">
                <label>土壤检测设备</label>
                <span>8769</span>
              </div>
            </div>
          </div> -->
          <div id="mapMain" class="map_main"></div>
          <div class="source">
            <chartTitle title="防伪溯源分析"></chartTitle>
            <div class="source_box">
              <div class="count">
                <span>溯源总数：</span>
                <span>14</span>
              </div>
              <div class="cow_sheep">
                <span>溯源牛只数：</span>
                <span>8</span>
              </div>
              <div class="cow_sheep">
                <span>溯源羊只数：</span>
                <span>6</span>
              </div>
            </div>
          </div>
        </div>
        <div class="box-item">
          <div class="device">
            <chartTitle title="活畜出栏" :optionsList="outList"></chartTitle>
            <div class="device_content" id="lineChart"></div>
          </div>
          <div class="service">
            <chartTitle title="区域对比" :optionsList="areaList"></chartTitle>
            <div class="service_content" id="columnChart"></div>
          </div>
        </div>
      </div>
      <video src="../../../../assets/yq/yqScreenVideo.mp4" autoplay="autoplay" loop class="fillWidth" muted='muted'>
      </video>
    </div>

  </div>
</template>
<script>
import chartTitle from '../components/indexChartItemTitle.vue'
import mapJson from '../../../../assets/map/150627.json'
export default {
  components: {
    chartTitle,
  },
  data() {
    return {
      tabList: [
        { text: '近1月', value: 1 },
        { text: '近3月', value: 3 },
        { text: '近6月', value: 6 },
      ],
      areaData: '3445',
      proData: [3456.87],
      lineData: [
        { value: 40, name: '大豆', total: '837.5' },
        { value: 38, name: '小麦', total: '734.8' },
        { value: 32, name: '甜菜', total: '123.3' },
        { value: 30, name: '玉米', total: '643.5' },
        { value: 28, name: '土豆', total: '467.7' },
      ],
      piedata1: [
        { value: 8739, name: '羊只总数', total: '30.2', color: '#00FEFF' },
        { value: 10267, name: '牛只总数', total: '30.8', color: '#F7BA1E' },
        { value: 3672, name: '驴只总数', total: '30.3', color: '#00FE65' }
      ],
      piedata2: [
        { value: 8739, name: '羊只总数', total: '30.2', color: '#3491FA' },
        { value: 10267, name: '牛只总数', total: '30.8', color: '#722ED1' },
        { value: 3672, name: '驴只总数', total: '30.3', color: '#F7BA1E' }
      ],
      typeList: [
        { value: 1, label: '牛' },
        { value: 2, label: '羊' },
      ],
      outList: [
        { value: 1, label: '全区域' },
      ],
      areaList: [
        { value: 1, label: '2023' },
        { value: 2, label: '2022' },
      ],
    }
  },
  watch: {},
  created() { },
  mounted() {
    this.$nextTick(() => {
      this.pieChart2({
        dom: 'areaChart',
        color: ['#00FEFF', '#F7BA1E', '#00FE65', '#14C9C9', '#165DFF'],
        data: this.piedata1,
        roseType: 'area'
      })
      this.pieChart2({
        dom: 'numPieChart',
        color: ['#3491FA', '#722ED1', '#F7BA1E', '#14C9C9', '#165DFF'],
        data: this.piedata2
      })
      this.initLineChart({
        dom: 'lineChart',
        xAxis: ['2000', '2001', '2002', '2003', '2004', '2005', '2006', '2022', '2023'],
        data1: [500, 6000, 4500, 3000, 700, 800, 300, 400, 500],
        data2: [300, 600, 400, 3000, 7500, 400, 200, 8400, 6000],
        data3: [3500, 800, 4300, 300, 500, 4000, 3200, 800, 5000],
      })
      this.initColumnChart()
      const mapData = [
        {
          name: '纳林陶亥镇',
          value: [110.11966302149337, 39.6283242456816],
        },
      ]
      const regions = [
        {
          name: '红庆河镇',
          itemStyle: { color: 'rgba(26, 87, 86, 0.4)' },
        },
        {
          name: '纳林陶亥镇',
          itemStyle: { color: 'rgba(17, 45, 109, 1)' },
        },
      ]
      this.initMap(mapData, regions)
    })
  },
  methods: {
    // 返回上一层
    goBack() {
      this.$router.go(-1)
    },
    // 初始化top-pie
    pieChart2(data) {
      this.chart = this.$echarts.init(document.getElementById(data.dom))
      this.chart.setOption({
        legend: {
          show: false,
          top: 'bottom',
          icon: 'circle',
          x: 'left',
          y: ' center',
          itemWidth: 10,
          itemHeight: 10,
          padding: [0, 0, 20, 40],
          textStyle: {
            color: '#FFFFFF',
          },
          formatter: (name) => {
            return this.getFormatter(data.data, name)
          },
        },
        grid: {
          left: '10%',
          right: '10%',
        },
        color: data.color, // 饼图各块颜色
        toolbox: {
          show: false,
        },
        series: [
          {
            type: 'pie',
            radius: [70, 110],
            center: ['50%', '50%'],
            roseType: data.roseType,
            itemStyle: {
              borderRadius: 0,
            },
            emphasis: {
              label: {
                show: true,
                formatter: data.roseType ? '{a|{c}}\n{b|{b}} ' : '{b|{b}}\n{a|{d}%} ',
                rich: {
                  a: {
                    fontSize: 20,
                    lineHeight: 36,
                    color: "#fff",
                    fontWeight: 'bold'
                  },
                  b: {
                    fontSize: 12,
                    lineHeight: 24,
                    color: "#fff"
                  }
                }
              }
            },
            label: {
              show: false,
              position: "center",
              color: "rgba(13, 17, 29,1)",
              fontSize: 14,
              formatter: '{a|{b}}\n{b|{c}} ',
              rich: {
                a: {
                  fontSize: 20,
                  lineHeight: 36,
                  color: "#fff"
                },
                b: {
                  fontSize: 16,
                  lineHeight: 24,
                  color: "#fff"
                }
              }
            },
            labelLine: {
              show: false
            },
            data: data.data,
          }
        ],
      })
    },

    // 初始化折线图
    initLineChart(data) {
      this.chart = this.$echarts.init(document.getElementById(data.dom))
      this.chart.setOption({
        color: ['#FFF200', '#40FF00', '#00E0DB'],
        title: {
          text: '',
        },
        legend: {
          icon: 'rectangle',
          data: [
            {
              name: '牛',
              textStyle: {
                fontSize: 12,
                color: '#FFF200',
              },
            },
            {
              name: '羊',
              textStyle: {
                fontSize: 12,
                color: '#40FF00',
              },
            },
            {
              name: '驴',
              textStyle: {
                fontSize: 12,
                color: '#00E0DB',
              },
            },
          ],
          x: 'center',
          y: 'top',
          itemWidth: 15,
          itemHeight: 2,
          padding: [30, 0, 0, 0],
        },
        /* tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(196,196,196,0.01);',
          borderColor: ' rgba(0,246,236,0.2)',
          boxShadow: 'inset 0rem 0rem 0.06rem 0rem rgba(0,117,255,0.6)',
          borderWidth: 2,
          textStyle: {
            color: '#fff',
          },
          formatter: function (data) {
            let dom = ''
            data.forEach((item) => {
              dom += `<p>
                                ${item.marker}
                                ${item.seriesName}：
                                ${item.value}只
                            </p>`
            })
            return `<div>${dom}</div>`
          },
        }, */
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(196,196,196,0.01);',
          borderColor: ' rgba(0,246,236,0.2)',
          boxShadow: 'inset 0rem 0rem 0.06rem 0rem rgba(0,117,255,0.6)',
          borderWidth: 2,
          textStyle: {
            color: '#fff',
          },
        },
        grid: {
          left: '1%',
          right: '3%',
          bottom: '0%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: true,
            axisLabel: {
              color: '#fff',
              interval: 0,
              // rotate: 40,
            },
            axisLine: {
              show: true, // X轴 网格线 颜色类型的修改
              lineStyle: {
                color: ' rgba(0,254,255,0.1)',
              },
            },
            axisTick: {
              // X轴线 刻度线
              show: false,
            },
            data: data.xAxis,
          },
        ],
        yAxis: [
          {
            name: '单位：头/只',
            nameTextStyle: {
              color: '#FFFFFF',
              padding: [1, 1],
            },
            splitLine: false,
            type: 'value',
            axisLine: {
              show: true, // Y轴线
              lineStyle: {
                color: ' rgba(0,254,255,0.1)',
              },
            },
            axisLabel: {
              color: '#FFFFFF',
            },
          },
        ],
        series: [
          { name: '牛', type: 'line', lineStyle: { width: 2, }, showSymbol: false, data: data.data1 },
          { name: '羊', type: 'line', lineStyle: { width: 2, }, showSymbol: false, data: data.data2 },
          { name: '驴', type: 'line', lineStyle: { width: 2, }, showSymbol: false, data: data.data3 },
        ],
      })
    },

    // 初始化柱状图
    initColumnChart() {
      this.chart = this.$echarts.init(document.getElementById('columnChart'))
      // 隐藏动画加载效果。
      this.chart.setOption({
        color: ['#165DFF', '#F7BA1E', '#722ED1', '#14C9C9', '#3491FA'],
        legend: {
          icon: 'circle',
          color: 'rgba(0,246,236,1)',
          data: [
            {
              name: '玉米',
              textStyle: {
                fontSize: 12,
                color: '#fff',
              },
            },
            {
              name: '大豆',
              textStyle: {
                fontSize: 12,
                color: '#fff',
              },
            },
            {
              name: '土豆',
              textStyle: {
                fontSize: 12,
                color: '#fff',
              },
            },
            {
              name: '小麦',
              textStyle: {
                fontSize: 12,
                color: '#fff',
              },
            },
            {
              name: '甜菜',
              textStyle: {
                fontSize: 12,
                color: '#fff',
              },
            },
            {
              name: '甜菜',
              textStyle: {
                fontSize: 12,
                color: '#fff',
              },
            },
            {
              name: '甜菜',
              textStyle: {
                fontSize: 12,
                color: '#fff',
              },
            },
            {
              name: '甜菜',
              textStyle: {
                fontSize: 12,
                color: '#fff',
              },
            },
          ],
          x: 'center',
          y: 'top',
          itemWidth: 8,
          itemHeight: 8,
          padding: [30, 0, 0, 0],
          borderRadius: '50%',
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(196,196,196,0.01);',
          borderColor: ' rgba(0,246,236,0.2)',
          boxShadow: 'inset 0rem 0rem 0.06rem 0rem rgba(0,117,255,0.6)',
          borderWidth: 2,
          textStyle: {
            color: '#fff',
          },
          formatter: function (data) {
            const name = data[0].name.split('\n')[0]
            let dom = `<div style='width: 150px'>
                            <h3 style='
                                text-align: center;
                                font-size: 16px;
                                font-weight: 400;
                                color: #FFFFFF;'>${name}</h3>
                            <div style='display: flex; flex-wrap: wrap'>
                        `
            data.forEach((item) => {
              dom += `<div style='width: 50%; display: flex;'>
                                <p>${item.marker}</p>
                                <div>
                                    <p style='color: #00FEFF;font-weight: 700;'>${item.value}</p>
                                    <p>${item.seriesName}</p>
                                </div>
                            </div>`
            })
            return `<div>${dom}</div>`
          },
        },
        grid: {
          left: '5%',
          right: '3%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: [
              {
                value: '阿勒腾席热镇',
                textStyle: {
                  lineHeight: 16,
                  formatter: ['{a}', '{b}'].join('\n'),
                },
              },
              {
                value: '乌兰木伦镇',
                textStyle: {
                  lineHeight: 16,
                  formatter: ['{a}', '{b}'].join('\n'),
                },
              },
              {
                value: '伊金霍洛镇',
                textStyle: {
                  lineHeight: 16,
                  formatter: ['{a}', '{b}'].join('\n'),
                },
              },
              {
                value: '设札萨克镇',
                textStyle: {
                  lineHeight: 16,
                  formatter: ['{a}', '{b}'].join('\n'),
                },
              },
              {
                value: '纳林陶亥镇',
                textStyle: {
                  lineHeight: 16,
                  formatter: ['{a}', '{b}'].join('\n'),
                },
              },
              {
                value: '红庆河镇',
                textStyle: {
                  lineHeight: 16,
                  formatter: ['{a}', '{b}'].join('\n'),
                },
              },
              {
                value: '苏布尔嘎镇',
                textStyle: {
                  lineHeight: 16,
                  formatter: ['{a}', '{b}'].join('\n'),
                },
              },
              // {
              //   value: '伊旗',
              //   textStyle: {
              //     lineHeight: 16,
              //     formatter: ['{a}', '{b}'].join('\n'),
              //   },
              // },
            ],
            axisPointer: {
              type: 'shadow',
            },
            axisLine: {
              show: true, // Y轴线
              lineStyle: {
                color: ' rgba(0,254,255,0.1)',
              },
            },
            axisTick: {
              // X轴线 刻度线
              show: false,
            },
            axisLabel: {
              color: '#05E9F7',
              rotate: 30,
            },
          },
        ],
        yAxis: [
          {
            name: '单位：吨',
            nameTextStyle: {
              color: '#FFFFFF',
              padding: [1, 1],
            },
            splitLine: false,
            axisLabel: {
              color: '#FFFFFF',
            },
          },
          {
            show: true,
          },
        ],
        series: [
          {
            name: '玉米',
            type: 'bar',
            barWidth: '6',
            barGap: 0,
            data: [76.7, 135.6, 162.2, 32.6, 23.4, 763, 334, 212],
            emphasis: {
              focus: 'series',
            },
            itemStyle: {
              //   barBorderRadius: [20, 20, 0, 0],
              color: '#165DFF',
            },
          },
          {
            name: '大豆',
            type: 'bar',
            barWidth: '6',
            barGap: 0,
            data: [28.7, 70.7, 175.6, 182.2, 343, 123, 234, 34],
            emphasis: {
              focus: 'series',
            },
            itemStyle: {
              //   barBorderRadius: [20, 20, 0, 0],
              color: '#F7BA1E',
            },
          },
          {
            name: '土豆',
            type: 'bar',
            barWidth: '6',
            barGap: 0,
            data: [70.7, 175.6, 182.2, 48.7, 98, 76, 35, 124],
            emphasis: {
              focus: 'series',
            },
            itemStyle: {
              //   barBorderRadius: [20, 20, 0, 0],
              color: '#722ED1',
            },
          },
          {
            name: '小麦',
            type: 'bar',
            barWidth: '6',
            barGap: 0,
            data: [175.6, 182.2, 48.7, 18.8, 88, 77, 89, 120],
            emphasis: {
              focus: 'series',
            },
            itemStyle: {
              //   barBorderRadius: [20, 20, 0, 0],
              color: '#14C9C9',
            },
          },
          {
            name: '甜菜',
            type: 'bar',
            barWidth: '6',
            barGap: 0,
            data: [17.6, 82.2, 148.7, 87.8, 98, 345, 87, 75],
            emphasis: {
              focus: 'series',
            },
            itemStyle: {
              //   barBorderRadius: [20, 20, 0, 0],
              color: '#3491FA',
            },
          },
        ],
      })
    },

    // 自定义饼图图例
    getFormatter(data, name) {
      let arr = []
      let count, amount
      for (const item of data) {
        if (item.name == name) {
          count = `${item.total}%`
          amount = item.value
        }
      }
      arr = [name, count, amount]
      return arr.join(' ')
    },

    /**
     * 初始化地图区域
     */
    initMap(data, regions) {
      const _this = this
      // 基于准备好的dom，初始化echarts实例
      var chart = this.$echarts.init(document.getElementById('mapMain'))

      this.$echarts.registerMap('bayannaoer', mapJson)
      // 隐藏动画加载效果。
      chart.hideLoading()

      let cahrtOption = {
        geo3D: {
          type: 'map3D', // 系列类型
          name: 'map3D', // 系列名称
          map: 'bayannaoer',
          boxHeight: 4,
          zoom: 1,
          label: {
            // 标签的相关设置
            show: false, // (地图上的城市名称)是否显示标签 [ default: false ]
            //distance: 50, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离
            //formatter:, // 标签内容格式器
            textStyle: {
              // 标签的字体样式
              color: '#000', // 地图初始化区域字体颜色
              fontSize: 8, // 字体大小
              opacity: 1, // 字体透明度
              backgroundColor: 'rgba(0,23,11,0)', // 字体背景色
            },
          },

          itemStyle: {
            // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
            color: 'rgba(51, 119, 171, 0.3)', // 地图板块的颜色
            opacity: 1, // 图形的不透明度 [ default: 1 ]
            borderWidth: 2, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
            borderColor: 'rgba(111,202,242, 0.8)', // 图形描边的颜色。[ default: #333 ]
          },

          emphasis: {
            // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
            label: {
              // label高亮时的配置
              show: false,
              textStyle: {
                color: '#fff', // 高亮时标签颜色变为 白色
                fontSize: 15, // 高亮时标签字体 变大
              },
              borderColor: '#08DAC8',
              borderWidth: 2,
              padding: 5,
              backgroundColor: 'red',
              extraCssText: 'box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;',
              formatter: function (params) {
                return ''
              },
            },
          },

          groundPlane: {
            // 地面可以让整个组件有个“摆放”的地方，从而使整个场景看起来更真实，更有模型感。
            show: false, // 是否显示地面。[ default: false ]
          },
          light: {
            // 光照相关的设置。在 shading 为 'color' 的时候无效。 光照的设置会影响到组件以及组件所在坐标系上的所有图表。合理的光照设置能够让整个场景的明暗变得更丰富，更有层次。
            main: {
              // 场景主光源的设置，在 globe 组件中就是太阳光。
              color: '#fff', //主光源的颜色。[ default: #fff ]
              intensity: 1.2, //主光源的强度。[ default: 1 ]
              shadow: false, //主光源是否投射阴影。默认关闭。 开启阴影可以给场景带来更真实和有层次的光照效果。但是同时也会增加程序的运行开销。
              shadowQuality: 'high', // 阴影的质量。可选'low', 'medium', 'high', 'ultra' [ default: 'medium' ]
              alpha: 55, // 主光源绕 x 轴，即上下旋转的角度。配合 beta 控制光源的方向。[ default: 40 ]
              beta: 10, // 主光源绕 y 轴，即左右旋转的角度。[ default: 40 ]
            },
          },

          viewControl: {
            // 用于鼠标的旋转，缩放等视角控制。
            projection: 'orthographic', // 投影方式，默认为透视投影'perspective'，也支持设置为正交投影'orthographic'。
            autoRotate: false, // 是否开启视角绕物体的自动旋转查看。[ default: false ]
            autoRotateDirection: 'cw', // 物体自传的方向。默认是 'cw' 也就是从上往下看是顺时针方向，也可以取 'ccw'，既从上往下看为逆时针方向。
            autoRotateSpeed: 10, // 物体自传的速度。单位为角度 / 秒，默认为10 ，也就是36秒转一圈。
            autoRotateAfterStill: 3, // 在鼠标静止操作后恢复自动旋转的时间间隔。在开启 autoRotate 后有效。[ default: 3 ]
            damping: 0, // 鼠标进行旋转，缩放等操作时的迟滞因子，在大于等于 1 的时候鼠标在停止操作后，视角仍会因为一定的惯性继续运动（旋转和缩放）。[ default: 0.8 ]
            rotateSensitivity: 1, // 旋转操作的灵敏度，值越大越灵敏。支持使用数组分别设置横向和纵向的旋转灵敏度。默认为1, 设置为0后无法旋转。 rotateSensitivity: [1, 0]——只能横向旋转； rotateSensitivity: [0, 1]——只能纵向旋转。
            zoomSensitivity: 1, // 缩放操作的灵敏度，值越大越灵敏。默认为1,设置为0后无法缩放。
            panSensitivity: 1, // 平移操作的灵敏度，值越大越灵敏。默认为1,设置为0后无法平移。支持使用数组分别设置横向和纵向的平移灵敏度
            panMouseButton: 'left', // 平移操作使用的鼠标按键，支持：'left' 鼠标左键（默认）;'middle' 鼠标中键 ;'right' 鼠标右键(注意：如果设置为鼠标右键则会阻止默认的右键菜单。)
            rotateMouseButton: 'left', // 旋转操作使用的鼠标按键，支持：'left' 鼠标左键;'middle' 鼠标中键（默认）;'right' 鼠标右键(注意：如果设置为鼠标右键则会阻止默认的右键菜单。)
            orthographicSize: 100,
            distance: 200, // [ default: 100 ] 默认视角距离主体的距离，对于 grid3D 和 geo3D 等其它组件来说是距离中心原点的距离,对于 globe 来说是距离地球表面的距离。在 projection 为'perspective'的时候有效。
            minDistance: 40, // [ default: 40 ] 视角通过鼠标控制能拉近到主体的最小距离。在 projection 为'perspective'的时候有效。
            maxDistance: 400, // [ default: 400 ] 视角通过鼠标控制能拉远到主体的最大距离。在 projection 为'perspective'的时候有效。

            alpha: 40, // 视角绕 x 轴，即上下旋转的角度。配合 beta 可以控制视角的方向。[ default: 40 ]
            beta: 15, // 视角绕 y 轴，即左右旋转的角度。[ default: 0 ]
            minAlpha: -45, // 上下旋转的最小 alpha 值。即视角能旋转到达最上面的角度。[ default: 5 ]
            maxAlpha: 45, // 上下旋转的最大 alpha 值。即视角能旋转到达最下面的角度。[ default: 90 ]
            minBeta: -45, // 左右旋转的最小 beta 值。即视角能旋转到达最左的角度。[ default: -80 ]
            maxBeta: 45, // 左右旋转的最大 beta 值。即视角能旋转到达最右的角度。[ default: 80 ]

            center: [0, 0, 0], // 视角中心点，旋转也会围绕这个中心点旋转，默认为[0,0,0]。

            animation: true, // 是否开启动画。[ default: true ]
            animationDurationUpdate: 1000, // 过渡动画的时长。[ default: 1000 ]
            animationEasingUpdate: 'cubicInOut', // 过渡动画的缓动效果。[ default: cubicInOut ]
          },
          regions: regions,
        },
        series: [
          {
            // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
            type: 'scatter3D',
            coordinateSystem: 'geo3D',
            symbol:
              'path://M16.05197563056946,26.8149C13.072275630569457,26.8576,10.101135630569459,26.4854,7.223625630569458,25.7088C3.458190630569458,24.5826,2.675675630569458,22.9872,2.675675630569458,21.8476C2.675675630569458,20.708,3.464878630569458,19.1058,7.210245630569458,17.9863C9.655305630569458,17.3057,12.177075630569458,16.9407,14.714375630569458,16.9004L14.781275630569459,16.3105C14.781275630569459,15.915,14.781275630569459,15.5396,14.841475630569459,15.1575C14.841475630569459,13.1464,13.503775630569457,11.5711,12.667795630569458,11.5711L12.580845630569458,11.5711C11.813295630569458,11.9313,10.980155630569458,12.1298,10.132975630569458,12.1543C9.730145630569458,12.1565,9.329125630569457,12.1,8.942485630569458,11.9867C7.930195630569458,11.7024,7.110225630569458,10.9575,6.728705630569458,9.97564C6.307345630569458,8.83605,4.641995630569458,8.31987,4.448035630569458,8.26625C3.890975630569458,8.14102,3.474606630569458,7.67523,3.411373630569458,7.10654C3.424827630569458,6.52191,3.827865630569458,6.01902,4.394535630569458,5.8798C5.649655630569458,5.46518,6.959155630569458,5.23927,8.280355630569458,5.20944C9.452155630569457,5.16981,10.611315630569457,5.46259,11.624435630569458,6.05409C13.001375630569457,6.93093,13.847775630569458,8.44142,13.878375630569458,10.0762C14.467175630569457,10.4504,14.978175630569458,10.9353,15.383175630569458,11.504C15.403675630569458,11.5237,15.429075630569457,11.5376,15.456775630569458,11.5443C15.498275630569458,11.5421,15.534875630569458,11.5159,15.550375630569459,11.4772C15.732875630569458,10.888,15.956375630569458,10.3123,16.21917563056946,9.75443C16.535775630569457,9.06628,16.942975630569457,8.42373,17.42977563056946,7.84393C17.43277563056946,7.81944,17.43277563056946,7.79467,17.42977563056946,7.77019C17.42767563056946,7.74274,17.412775630569456,7.71789,17.389675630569457,7.70315C17.235775630569456,7.60297,17.08837563056946,7.49327,16.94817563056946,7.37468C16.592975630569455,7.09066,16.39017563056946,6.65689,16.399775630569458,6.20156C16.399775630569458,6.05409,16.399775630569458,2.50122,19.18877563056946,0.83875C20.124175630569457,0.272958,21.19967563056946,-0.0174341,22.292075630569457,0.000811119C24.064375630569458,0.000811119,26.177875630569456,0.630942,28.57897563056946,1.87109C29.10077563056946,2.13893,29.41757563056946,2.68831,29.38877563056946,3.27519C29.35987563056946,3.86207,28.99067563056946,4.37758,28.44517563056946,4.59272C26.753875630569457,5.30059,25.210975630569457,6.32172,23.897175630569457,7.6026C23.24517563056946,8.31356,22.35967563056946,8.76565,21.40257563056946,8.87627L20.91427563056946,8.87627C20.33097563056946,8.86994,19.75267563056946,8.76804,19.202175630569457,8.57461C18.552375630569458,9.05222,18.05887563056946,9.71251,17.784275630569457,10.4717C16.88997563056946,12.4454,16.464175630569457,14.6,16.540275630569457,16.7663C19.35067563056946,16.8353,22.14327563056946,17.2358,24.860275630569458,17.9595C28.612375630569456,19.079,29.39487563056946,20.6812,29.39487563056946,21.8208C29.39487563056946,22.9604,28.612375630569456,24.5558,24.860275630569458,25.682C21.99057563056946,26.4659,19.026275630569458,26.8472,16.05197563056946,26.8149ZM9.450785630569458,19.1729C8.855535630569458,19.2935,8.313795630569459,19.4343,7.832245630569458,19.5751C5.772295630569458,20.1918,4.595175630569458,21.023,4.595175630569458,21.8476C4.595175630569458,22.6721,5.772295630569458,23.5033,7.825565630569458,24.1335C10.507935630569458,24.8487,13.276875630569458,25.1849,16.05197563056946,25.1323C18.81367563056946,25.1797,21.56867563056946,24.8436,24.238275630569458,24.1335C26.291575630569458,23.5234,27.468675630569457,22.6922,27.468675630569457,21.8677C27.468675630569457,21.0431,26.291575630569458,20.2119,24.238275630569458,19.5952C23.76347563056946,19.4544,23.21497563056946,19.3203,22.619775630569457,19.193Q22.51947563056946,19.193,22.512775630569458,19.2466C22.487075630569457,19.2802,22.487075630569457,19.3269,22.512775630569458,19.3606C22.96777563056946,19.6956,23.24987563056946,20.2167,23.28187563056946,20.7817C23.28187563056946,22.8866,19.523175630569458,23.8385,16.031975630569455,23.8385C12.540715630569458,23.8385,8.78196563056946,22.8799,8.78196563056946,20.7817C8.803415630569457,20.2149,9.078585630569458,19.6879,9.531045630569459,19.3472C9.541295630569458,19.3099,9.541295630569458,19.2705,9.531045630569459,19.2332C9.515185630569459,19.1997,9.48110563056946,19.1786,9.444095630569457,19.1796L9.450785630569458,19.1729ZM18.633675630569456,7.92437C19.890975630569457,3.68775,24.14467563056946,1.77724,29.22097563056946,3.15817C29.30797563056946,3.1838,29.398875630569457,3.13218,29.421675630569457,3.04421C29.447475630569457,2.95535,29.39657563056946,2.86232,29.30797563056946,2.8364C24.07777563056946,1.40185,19.630175630569457,3.4062,18.319275630569457,7.82381C18.288775630569457,7.91103,18.337675630569457,8.00602,18.426275630569457,8.03162L18.473075630569458,8.03162C18.54387563056946,8.03353,18.608175630569455,7.99057,18.633675630569456,7.92437ZM13.283075630569458,11.1957C13.368275630569459,11.1589,13.407275630569458,11.0596,13.370075630569458,10.9745C12.373515630569457,8.64164,8.60807563056946,5.84628,3.371245630569458,6.95236C3.280494630569458,6.97236,3.223419630569458,7.06268,3.244170630569458,7.15346C3.264180630569458,7.24125,3.3498336305694583,7.2975,3.438127630569458,7.28083C8.494375630569458,6.22838,12.132735630569458,8.88967,13.069075630569458,11.1219C13.094775630569458,11.181,13.151975630569458,11.2201,13.216175630569458,11.2225L13.283075630569458,11.1957Z',
            symbolSize: 20,
            itemStyle: {
              normal: {
                color: '#40FF00',
              },
            },
            data: [
              {
                name: '纳林陶亥镇',
                value: [110.01666302149337, 39.6283242456816, 100]
              },
              {
                name: '纳林陶亥镇',
                value: [110.01666302149337, 39.6883242456816, 100]
              },
              {
                name: '纳林陶亥镇',
                value: [110.11666302149337, 39.4883242456816, 100]
              },
              {
                name: '纳林陶亥镇',
                value: [110.11566302149337, 39.6883242456816, 100]
              },
              {
                name: '纳林陶亥镇',
                value: [110.21666302149337, 39.4883242456816, 100]
              },
              {
                name: '纳林陶亥镇',
                value: [110.31666302149337, 39.4883242456816, 100]
              },
              {
                name: '札萨克镇',
                value: [109.58768632322884, 39.2319626655842]
              }
            ],
          },
          {
            // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
            type: 'scatter3D',
            coordinateSystem: 'geo3D',
            symbol:
              'path://M15.873735396194459,23.884034228515624C15.801735396194458,23.884034228515624,15.732735396194458,23.881034228515624,15.663735396194458,23.875034228515624C15.756735396194458,23.797034228515624,15.828735396194459,23.698034228515624,15.879735396194459,23.578034228515627C15.930735396194459,23.698034228515624,16.00273539619446,23.797034228515624,16.095735396194456,23.875034228515624C16.026735396194457,23.881034228515624,15.957735396194458,23.884034228515624,15.885735396194457,23.884034228515624L15.873735396194459,23.884034228515624ZM9.270705396194458,12.591994228515624L9.267705396194458,12.603994228515624C9.141705396194457,13.050994228515625,9.060705396194457,13.359994228515625,9.063715396194457,13.635994228515624L9.042715396194458,13.635994228515624C8.943705396194458,13.170994228515625,8.772705396194457,12.678994228515625,8.529705396194458,12.144994228515625L8.439705396194459,11.949994228515624C8.664705396194458,12.069994228515625,8.895705396194458,12.222994228515624,9.126705396194458,12.408994228515624C9.141705396194457,12.420994228515625,9.153705396194457,12.429994228515625,9.162705396194458,12.435994228515625C9.212935396194458,12.473124228515626,9.28184539619446,12.471894228515625,9.330705396194457,12.432994228515625C9.309705396194458,12.483994228515625,9.291705396194459,12.537994228515625,9.270705396194458,12.591994228515624ZM8.205705396194457,11.538994228515625C7.635705396194458,11.301994228515625,7.0987053961944575,11.253994228515625,6.633705396194458,11.409994228515625C6.5617053961944585,11.433994228515626,6.525705396194458,11.511994228515626,6.549705396194458,11.580994228515625C6.552705396194458,11.595994228515625,6.5617053961944585,11.607994228515626,6.567705396194458,11.619994228515626L6.522705396194458,11.655994228515624C6.4687053961944585,11.583994228515625,6.414705396194458,11.514994228515626,6.369705396194458,11.457994228515625C6.981705396194458,11.091994228515624,7.593705396194458,10.908994228515624,8.193705396194458,10.902994228515624C8.412705396194458,10.899994228515624,8.631705396194459,10.923994228515625,8.847705396194458,10.968994228515625C9.306705396194458,11.067994228515625,9.627705396194457,11.256994228515625,9.765705396194459,11.343994228515625C9.633705396194458,11.655994228515624,9.501705396194458,11.976994228515625,9.375705396194459,12.306994228515624C9.37202539619446,12.273554228515625,9.354645396194458,12.243144228515625,9.327705396194457,12.222994228515624C9.318705396194458,12.216994228515624,9.309705396194458,12.207994228515625,9.294705396194459,12.195994228515625C8.946705396194458,11.919994228515625,8.601705396194458,11.709994228515626,8.265705396194459,11.562994228515624L8.193705396194458,11.403994228515625L8.205705396194457,11.538994228515625ZM8.217705396194457,13.518994228515625C7.695705396194458,13.368994228515625,7.065705396194458,12.993994228515625,6.759705396194458,12.078994228515626L6.753705396194459,12.063994228515625C6.711705396194458,11.937994228515624,6.618705396194458,11.787994228515625,6.522705396194458,11.655994228515624L6.567705396194458,11.619994228515626C6.600705396194458,11.664994228515624,6.663705396194458,11.682994228515625,6.717705396194458,11.664994228515624C7.158705396194458,11.517994228515626,7.680705396194458,11.580994228515625,8.238705396194458,11.844994228515624L8.274705396194458,12.213994228515624C8.274705396194458,12.222994228515624,8.331705396194458,12.831994228515626,8.217705396194457,13.518994228515625ZM23.520735396194457,11.844994228515624C24.078735396194457,11.580994228515625,24.60073539619446,11.517994228515626,25.041735396194458,11.664994228515624C25.095735396194456,11.682994228515625,25.15573539619446,11.664994228515624,25.191735396194456,11.619994228515626L25.236735396194458,11.655994228515624C25.140735396194458,11.787994228515625,25.047735396194458,11.937994228515624,25.005735396194456,12.063994228515625L24.99973539619446,12.078994228515626C24.69373539619446,12.993994228515625,24.06373539619446,13.368994228515625,23.541735396194458,13.518994228515625C23.427735396194457,12.831994228515626,23.48473539619446,12.222994228515624,23.48473539619446,12.213994228515624L23.520735396194457,11.844994228515624ZM23.229735396194457,12.144994228515625C22.986735396194458,12.678994228515625,22.81573539619446,13.170994228515625,22.71673539619446,13.635994228515624L22.695735396194458,13.635994228515624C22.698735396194458,13.359994228515625,22.61773539619446,13.050994228515625,22.491735396194457,12.603994228515624L22.488735396194457,12.591994228515624C22.46773539619446,12.537994228515625,22.44973539619446,12.483994228515625,22.428735396194458,12.432994228515625C22.477735396194458,12.471484228515624,22.546335396194458,12.472714228515624,22.596735396194457,12.435994228515625C22.605735396194458,12.429994228515625,22.61773539619446,12.420994228515625,22.63273539619446,12.408994228515624C22.863735396194457,12.222994228515624,23.09473539619446,12.069994228515625,23.319735396194456,11.949994228515624L23.229735396194457,12.144994228515625ZM23.56573539619446,10.908994228515624C24.084735396194457,10.914994228515624,24.70273539619446,11.052994228515626,25.389735396194457,11.457994228515625C25.34473539619446,11.514994228515626,25.290735396194457,11.583994228515625,25.236735396194458,11.655994228515624L25.191735396194456,11.619994228515626C25.197735396194457,11.607994228515626,25.203735396194457,11.595994228515625,25.209735396194457,11.580994228515625C25.234135396194457,11.510554228515625,25.196335396194456,11.433734228515625,25.125735396194457,11.409994228515625C24.657735396194457,11.253994228515625,24.12073539619446,11.298994228515625,23.553735396194458,11.535994228515625L23.56573539619446,11.403994228515625L23.49373539619446,11.559994228515624C23.157735396194457,11.706994228515626,22.81273539619446,11.919994228515625,22.46473539619446,12.195994228515625C22.44973539619446,12.207994228515625,22.44073539619446,12.216994228515624,22.43173539619446,12.222994228515624C22.404735396194457,12.243994228515625,22.386735396194457,12.273994228515626,22.383735396194457,12.306994228515624C22.25473539619446,11.976994228515625,22.125735396194457,11.655994228515624,21.99373539619446,11.343994228515625C22.18573539619446,11.220994228515625,22.74973539619446,10.899994228515624,23.56573539619446,10.908994228515624ZM22.950735396194457,13.821994228515624C23.00773539619446,13.533994228515626,23.09173539619446,13.230994228515625,23.20573539619446,12.912994228515625C23.21473539619446,13.152994228515626,23.241735396194457,13.431994228515626,23.30173539619446,13.716994228515626C23.358735396194458,14.010994228515624,23.448735396194458,14.313994228515625,23.58673539619446,14.589994228515625C23.886735396194457,15.193034228515625,24.447735396194457,15.655034228515625,24.951735396194458,15.715034228515625C24.97573539619446,15.718034228515625,25.002735396194456,15.718034228515625,25.029735396194457,15.718034228515625C25.032735396194457,15.721034228515625,25.035735396194458,15.721034228515625,25.038735396194458,15.721034228515625C25.050735396194458,15.724034228515626,25.06573539619446,15.727034228515626,25.07773539619446,15.727034228515626L25.08673539619446,15.727034228515626C25.113735396194457,15.724034228515626,25.143735396194458,15.721034228515625,25.17073539619446,15.715034228515625C25.191735396194456,15.712034228515625,25.212735396194457,15.709034228515625,25.236735396194458,15.703034228515625C25.26673539619446,15.700034228515625,25.293735396194457,15.694034228515624,25.320735396194458,15.682034228515626C25.779735396194457,15.553034228515624,26.058735396194457,15.106034228515625,26.127735396194456,14.944034228515624C26.130735396194456,14.938034228515624,26.130735396194456,14.932034228515626,26.133735396194457,14.929034228515626C26.28073539619446,14.643994228515625,26.38573539619446,14.292994228515624,26.436735396194457,13.887994228515625C26.535735396194458,13.125994228515625,26.430735396194457,12.291994228515625,26.151735396194457,11.598994228515625C25.968735396194457,11.142994228515626,25.72273539619446,10.767994228515626,25.419735396194458,10.491994228515626C25.413735396194458,10.479994228515626,25.404735396194457,10.473994228515625,25.395735396194457,10.467994228515625C25.263035396194457,10.342874228515626,25.113635396194457,10.236854228515625,24.951735396194458,10.152994228515624C24.918735396194457,10.131994228515625,24.88273539619446,10.113994228515626,24.849735396194458,10.098994228515625C24.819735396194456,10.083994228515625,24.78673539619446,10.068994228515624,24.756735396194458,10.059994228515624C24.71473539619446,10.038994228515625,24.675735396194458,10.023994228515626,24.633735396194457,10.011994228515626C24.450735396194457,9.948994228515625,24.285735396194458,9.936994228515626,24.13273539619446,9.969994228515624C23.739735396194458,10.059994228515624,23.56573539619446,10.431994228515624,23.48173539619446,10.611994228515625C23.47873539619446,10.620994228515624,23.47273539619446,10.629994228515624,23.46973539619446,10.638994228515624C23.232735396194457,10.641994228515625,23.01973539619446,10.671994228515626,22.83973539619446,10.710994228515625C22.383735396194457,10.809994228515624,22.053735396194458,10.986994228515625,21.88573539619446,11.097994228515624C21.04573539619446,9.174994228515626,20.133735396194457,7.677994228515625,19.689735396194457,7.221994228515625C19.46473539619446,6.987994228515625,19.27273539619446,6.834994228515625,19.029735396194457,6.780994228515625C19.23193539619446,6.457194228515625,19.47383539619446,6.159904228515625,19.74973539619446,5.895994228515625C20.28973539619446,5.376992228515625,21.921735396194457,3.7989922285156252,25.35673539619446,5.433992228515625C28.959735396194457,7.1499942285156255,28.971735396194457,12.759994228515625,28.18573539619446,14.773034228515625C28.16473539619446,14.830034228515625,28.140735396194458,14.887034228515626,28.119735396194457,14.947034228515625C27.822735396194457,15.715034228515625,27.489735396194458,16.588034228515625,26.523735396194457,17.077034228515625C25.761735396194457,17.461034228515626,24.98173539619446,17.512034228515624,24.33073539619446,17.224034228515627C23.68573539619446,16.939034228515624,23.226735396194456,16.351034228515623,22.99873539619446,15.523034228515625C22.851735396194456,14.995034228515625,22.83673539619446,14.436994228515625,22.950735396194457,13.821994228515624ZM15.165735396194458,23.773034228515623C13.434735396194458,23.212034228515623,12.663705396194459,20.659034228515623,12.132705396194458,18.901034228515627C11.892705396194458,18.112034228515626,11.703705396194458,17.488034228515623,11.481705396194458,17.185034228515626C11.223705396194458,16.834034228515627,10.950715396194457,16.420034228515625,10.668705396194458,15.949034228515625C10.71371539619446,15.991034228515625,10.755705396194458,16.030034228515625,10.79770539619446,16.063034228515626C11.250705396194459,16.435034228515626,11.703705396194458,16.675034228515624,11.724705396194459,16.687034228515625C11.790135396194458,16.721134228515623,11.870865396194459,16.695534228515626,11.904705396194458,16.630034228515626C11.940705396194458,16.564034228515624,11.916715396194459,16.483034228515624,11.850705396194458,16.447034228515626C11.844715396194458,16.444034228515626,11.400715396194459,16.210034228515624,10.968715396194458,15.853034228515625C10.710715396194459,15.640034228515624,10.314705396194459,15.202034228515625,10.095715396194457,14.956034228515625C10.002715396194457,14.848034228515624,9.939715396194458,14.776034228515625,9.939715396194458,14.773034228515625C9.189705396194459,13.866994228515624,9.234715396194458,13.704994228515625,9.525715396194457,12.681994228515624C9.696715396194458,12.219994228515624,9.876715396194458,11.769994228515625,10.05971539619446,11.340994228515626C10.899715396194459,9.384994228515625,11.820715396194458,7.863994228515625,12.261715396194457,7.407994228515625C12.513705396194458,7.146994228515625,12.678715396194457,7.026994228515624,12.948715396194459,7.026994228515624L12.984715396194458,7.026994228515624C13.041705396194457,7.0299942285156245,13.452735396194457,7.068994228515625,13.689735396194457,7.107994228515625C13.890735396194458,7.140994228515625,14.451735396194458,7.272994228515625,14.559735396194458,7.296994228515625C14.562735396194459,7.299994228515625,14.565735396194459,7.299994228515625,14.568735396194459,7.299994228515625Q14.574735396194457,7.302994228515625,14.577735396194457,7.302994228515625C14.586735396194458,7.305994228515625,14.595735396194458,7.305994228515625,14.604735396194458,7.305994228515625L14.616735396194459,7.305994228515625C15.108735396194458,7.272984228515625,15.246735396194458,7.275994228515625,15.525735396194458,7.278994228515625L16.230735396194458,7.278994228515625C16.512735396194458,7.275994228515625,16.650735396194456,7.272984228515625,17.13973539619446,7.305994228515625L17.151735396194457,7.305994228515625C17.163735396194458,7.305994228515625,17.172735396194458,7.305994228515625,17.18173539619446,7.302994228515625Q17.18473539619446,7.302994228515625,17.19073539619446,7.299994228515625C17.19373539619446,7.299994228515625,17.196735396194455,7.299994228515625,17.199735396194455,7.296994228515625C17.30773539619446,7.272994228515625,17.86873539619446,7.140994228515625,18.06973539619446,7.107994228515625C18.30673539619446,7.068994228515625,18.717735396194456,7.0299942285156245,18.77473539619446,7.026994228515624L18.81373539619446,7.026994228515624C19.080735396194456,7.026994228515624,19.24573539619446,7.146994228515625,19.497735396194457,7.407994228515625C19.93873539619446,7.863994228515625,20.85973539619446,9.384994228515625,21.69973539619446,11.340994228515626C21.88273539619446,11.769994228515625,22.06273539619446,12.219994228515624,22.233735396194458,12.681994228515624C22.52473539619446,13.704994228515625,22.566735396194456,13.866994228515624,21.822735396194457,14.773034228515625C21.819735396194456,14.776034228515625,21.756735396194458,14.848034228515624,21.663735396194458,14.956034228515625C21.441735396194456,15.202034228515625,21.04573539619446,15.640034228515624,20.787735396194456,15.853034228515625C20.51393539619446,16.078034228515627,20.21963539619446,16.276934228515625,19.90873539619446,16.447034228515626C19.843535396194458,16.482734228515625,19.81833539619446,16.563634228515625,19.851735396194456,16.630034228515626C19.878735396194458,16.675034228515624,19.92373539619446,16.702034228515625,19.971735396194457,16.702034228515625C19.99273539619446,16.702034228515625,20.01373539619446,16.696034228515625,20.034735396194456,16.687034228515625C20.052735396194457,16.675034228515624,20.505735396194456,16.435034228515626,20.96173539619446,16.063034228515626C21.000735396194457,16.030034228515625,21.04573539619446,15.991034228515625,21.090735396194457,15.949034228515625C20.808735396194457,16.420034228515625,20.535735396194458,16.834034228515627,20.27773539619446,17.185034228515626C20.055735396194457,17.488034228515623,19.866735396194457,18.112034228515626,19.62673539619446,18.901034228515627C19.095735396194456,20.659034228515623,18.324735396194455,23.212034228515623,16.593735396194457,23.773034228515623C16.53673539619446,23.773034228515623,16.38973539619446,23.770034228515627,16.266735396194456,23.668034228515626C16.140735396194458,23.560034228515626,16.06573539619446,23.377034228515626,16.047735396194458,23.122034228515624C16.14973539619446,23.095034228515626,16.305735396194457,23.047034228515624,16.458735396194456,22.966034228515625C16.491735396194457,23.029034228515624,16.56973539619446,23.059034228515625,16.635735396194455,23.026034228515623C17.205735396194456,22.759034228515624,17.169735396194458,22.612034228515626,17.154735396194457,22.549034228515627C17.11273539619446,22.378034228515624,16.872735396194457,22.387034228515624,16.75573539619446,22.393034228515624L16.683735396194457,22.396034228515624L16.644735396194456,22.459034228515623C16.455735396194456,22.777034228515625,15.888735396194457,22.882034228515625,15.882735396194459,22.885034228515625L15.873735396194459,22.885034228515625C15.717735396194458,22.855034228515624,15.270735396194459,22.726034228515626,15.114735396194458,22.459034228515623L15.075735396194458,22.396034228515624L15.003735396194458,22.393034228515624C14.886735396194458,22.387034228515624,14.646735396194458,22.378034228515624,14.604735396194458,22.549034228515627C14.589735396194458,22.612034228515626,14.553735396194458,22.759034228515624,15.123735396194459,23.026034228515623C15.189735396194457,23.059034228515625,15.267735396194459,23.029034228515624,15.300735396194458,22.966034228515625C15.453735396194459,23.047034228515624,15.609735396194457,23.095034228515626,15.711735396194458,23.122034228515624C15.693735396194459,23.377034228515626,15.621735396194458,23.560034228515626,15.495735396194458,23.665034228515626C15.369735396194457,23.770034228515627,15.225735396194459,23.773034228515623,15.165735396194458,23.773034228515623ZM20.430735396194457,13.851994228515625C20.49403539619446,13.812234228515624,20.511735396194457,13.727844228515625,20.46973539619446,13.665994228515626C20.428735396194458,13.604454228515625,20.34593539619446,13.587104228515624,20.28373539619446,13.626994228515626C18.97873539619446,14.487994228515625,19.239735396194458,15.289034228515625,19.25173539619446,15.322034228515625C19.26973539619446,15.379034228515625,19.320735396194458,15.415034228515625,19.377735396194456,15.415034228515625C19.392735396194457,15.415034228515625,19.407735396194457,15.412034228515624,19.422735396194458,15.406034228515624C19.491835396194457,15.380634228515625,19.527835396194458,15.304534228515625,19.503735396194458,15.235034228515625C19.503735396194458,15.229034228515625,19.299735396194457,14.598994228515625,20.430735396194457,13.851994228515625ZM12.507715396194458,15.322034228515625C12.519715396194458,15.289034228515625,12.780715396194458,14.487994228515625,11.475705396194458,13.626994228515626C11.413515396194459,13.586754228515625,11.330505396194457,13.604164228515625,11.289705396194458,13.665994228515626C11.247675396194458,13.727844228515625,11.265365396194458,13.812234228515624,11.328715396194458,13.851994228515625C12.438715396194459,14.586994228515625,12.261715396194457,15.208034228515626,12.252705396194457,15.238034228515625C12.231705396194458,15.307034228515626,12.267705396194458,15.382034228515625,12.336705396194459,15.406034228515624C12.351705396194458,15.412034228515624,12.366705396194458,15.415034228515625,12.381705396194459,15.415034228515625C12.435705396194457,15.415034228515625,12.489705396194458,15.379034228515625,12.507715396194458,15.322034228515625ZM6.522705396194458,15.703034228515625C6.546705396194458,15.709034228515625,6.567705396194458,15.712034228515625,6.588705396194458,15.715034228515625C6.615705396194458,15.721034228515625,6.645705396194458,15.724034228515626,6.672705396194457,15.727034228515626L6.681705396194458,15.727034228515626C6.693705396194458,15.727034228515626,6.708705396194458,15.724034228515626,6.720705396194457,15.721034228515625C6.7237053961944575,15.721034228515625,6.726715396194458,15.721034228515625,6.729715396194457,15.718034228515625C6.756715396194458,15.718034228515625,6.783715396194458,15.718034228515625,6.8077153961944585,15.715034228515625C7.311715396194458,15.655034228515625,7.872715396194458,15.193034228515625,8.17270539619446,14.589994228515625C8.307705396194457,14.313994228515625,8.400705396194457,14.010994228515624,8.457715396194459,13.716994228515626C8.514705396194458,13.431994228515626,8.544715396194459,13.152994228515626,8.553715396194459,12.912994228515625C8.667715396194458,13.230994228515625,8.751705396194458,13.530994228515626,8.808715396194458,13.821994228515624C8.922715396194459,14.436994228515625,8.904715396194458,14.995034228515625,8.760715396194458,15.523034228515625C8.532715396194458,16.351034228515623,8.070715396194458,16.939034228515624,7.428715396194458,17.224034228515627C6.774715396194458,17.512034228515624,5.997715396194458,17.461034228515626,5.235715396194458,17.077034228515625C4.269715396194458,16.588034228515625,3.9367103961944583,15.715034228515625,3.639710396194458,14.947034228515625C3.618710396194458,14.887034228515626,3.594710396194458,14.830034228515625,3.573710396194458,14.773034228515625C2.784710396194458,12.759994228515625,2.799710396194458,7.1499942285156255,6.402715396194457,5.433991228515625C9.834715396194458,3.798991228515625,11.469715396194458,5.376991228515625,12.006705396194459,5.895994228515625C12.294715396194459,6.171994228515625,12.537715396194457,6.468994228515625,12.732705396194458,6.780994228515625C12.486715396194459,6.834994228515625,12.294705396194457,6.987994228515625,12.066715396194459,7.221994228515625C11.622715396194458,7.677994228515625,10.710715396194459,9.174994228515626,9.870705396194458,11.094994228515624C9.702705396194457,10.986994228515625,9.372705396194458,10.809994228515624,8.916705396194459,10.710994228515625C8.73670539619446,10.671994228515626,8.526705396194458,10.641994228515625,8.289705396194458,10.638994228515624C8.286705396194458,10.629994228515624,8.280705396194458,10.620994228515624,8.277705396194458,10.611994228515625C8.193705396194458,10.431994228515624,8.019705396194457,10.059994228515624,7.626705396194458,9.969994228515624C7.476705396194458,9.936994228515626,7.308705396194458,9.948994228515625,7.1257053961944585,10.011994228515626C7.056705396194458,10.032994228515625,6.9847053961944585,10.062994228515624,6.9097053961944574,10.098994228515625C6.876705396194458,10.113994228515626,6.840705396194458,10.131994228515625,6.807705396194458,10.152994228515624C6.6547053961944584,10.230994228515625,6.510705396194458,10.332994228515625,6.378705396194459,10.452994228515625C6.363705396194458,10.464994228515625,6.3487053961944575,10.476994228515625,6.336705396194458,10.491994228515626C6.036705396194458,10.770994228515626,5.790705396194458,11.142994228515626,5.607705396194458,11.598994228515625C5.328705396194458,12.291994228515625,5.2237053961944575,13.125994228515625,5.322705396194458,13.887994228515625C5.373705396194458,14.292994228515624,5.478705396194458,14.643994228515625,5.6257053961944585,14.929034228515626C5.628705396194459,14.932034228515626,5.628705396194459,14.938034228515624,5.631705396194458,14.944034228515624C5.700705396194458,15.106034228515625,5.979705396194458,15.553034228515624,6.438705396194457,15.682034228515626C6.465705396194458,15.694034228515624,6.492705396194458,15.700034228515625,6.522705396194458,15.703034228515625Z',
            symbolSize: 20,
            itemStyle: {
              normal: {
                color: '#FFF200',
                areaColor: {
                  repeat: 'repeat',
                },
              },
            },
            data: [
              {
                name: '红庆河镇',
                value: [109.24529833729624, 39.40334414691005, 100]
              },

              {
                name: '红庆河镇',
                value: [109.48529833729624, 39.40334414691005, 100]
              },
              {
                name: '红庆河镇',
                value: [109.34529833729624, 39.40334414691005, 100]
              },

              {
                name: '红庆河镇',
                value: [109.68529833729624, 39.10334414691005, 100]
              },
              {
                name: '红庆河镇',
                value: [109.44529833729624, 39.30334414691005, 100]
              },

              {
                name: '红庆河镇',
                value: [109.49529833729624, 39.29334414691005, 100]
              },

              {
                name: '红庆河镇',
                value: [109.17529833729624, 39.49334414691005, 100]
              }
            ],
          },
        ],
      }
      chart.setOption(cahrtOption)
    },
  },
}
</script>
<style lang="scss" scoped>
.main {
  width: 24rem;
  // height: 13.5rem;
  min-height: 100vh;
  margin: 0 auto;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  // background: url('../../../../assets/yq/agriculture_bg.png');

  .head {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 1.2rem;
    background: url('../../../../assets/yq/head_index_bg.png');
    background-size: 100% 100%;
    font-size: 0.55rem;
    font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
    font-weight: 700;
    color: #ffffff;
    letter-spacing: 5px;
  }

  .section {
    box-sizing: border-box;
    display: flex;
    flex: 1;
    flex-direction: column;
    // min-height: 12.5rem;
    // min-height: calc(100vh - 1rem);
    position: relative;
    border: none;

    .gobcak {
      width: 2.25rem;
      height: 0.4375rem;
      position: absolute;
      z-index: 99;
      top: 0.175rem;
      left: 0.25rem;
      font-size: 0.2rem;
      font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
      font-weight: 400;
      color: #fdfdfd;
      display: flex;
      align-items: center;
      cursor: pointer;

      img {
        width: 0.3rem;
        height: 0.3rem;
      }

      span {
        margin-left: 0.05rem;
      }
    }

    .box {
      width: 100%;
      display: flex;
      // background: url('../../../assets/yq/fold/rectangle1.png');
      background-size: 100% 100%;
      margin-top: 1rem;
      padding: 0 0.26rem;

      .box-item {
        .top-l {
          background: linear-gradient(90deg, rgba(11, 40, 106, 0.62) 0%, rgba(11, 40, 106, 0.19) 57%, rgba(11, 40, 106, 0.62) 100%);
        }

        width: 5.75rem;

        .plant_centent {
          width: 5.75rem;
          height: 4.78rem;
          // background: linear-gradient(90deg, rgba(11, 40, 106, 0.62) 0%, rgba(11, 40, 106, 0.19) 57%, rgba(11, 40, 106, 0.62) 100%);
          opacity: 0.94;
          margin-top: 0.11rem;
          display: flex;

          .plant_type {
            display: flex;
            padding-top: 0.66rem;

            .plant_type_r,
            .plant_type_l {
              flex: 1;
            }

            .plant_type_item {
              // flex: 1;
              display: flex;
              padding-left: 0.48rem;

              img {
                width: 0.74rem;
                height: 0.74rem;
                margin-right: 0.25rem;
              }

              div {
                display: flex;
                flex-direction: column;

                span {
                  font-size: 0.38rem;
                  font-family: Impact-Regular, Impact;
                  font-weight: 400;
                  color: #fff200;
                  line-height: 0.5rem;
                  letter-spacing: 1px;
                }

                label {
                  font-size: 0.18rem;
                  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                  font-weight: 400;
                  color: #ffffff;
                  opacity: 0.45;
                }
              }
            }

            .count_item {
              flex: 1;
              display: flex;
              flex-direction: column;
              padding-left: 0.48rem;
              margin-top: 0.7rem;
              position: relative;

              label {
                font-size: 0.18rem;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #ffffff;
                margin-bottom: 0.18rem;
                opacity: 0.45;
              }

              span {
                font-size: 0.33rem;
                font-family: Impact-Regular, Impact;
                font-weight: 400;
                color: #ffffff;
                line-height: 0.28rem;
                letter-spacing: 1px;

                i {
                  font-style: normal;
                  font-size: 0.2rem;
                  color: #fafafa;
                  opacity: 0.45;
                }
              }
            }

            .plant_count,
            .animal_count {
              padding-left: 0.79rem;

              &::before {
                content: '';
                width: 0.08rem;
                height: 0.38rem;
                background: #00e0db;
                border-radius: 1.25rem 1.25rem 1.25rem 1.25rem;
                position: absolute;
                left: 0.48rem;
                top: 0.11rem;
              }
            }

            .animal_count {
              &::before {
                background: #5d2cfe;
              }
            }
          }
        }

        .warrning {
          margin-top: 0.36rem;
          background: linear-gradient(154deg, #0b286a 0%, rgba(11, 40, 106, 0.19) 57%, #0b286a 100%);
          height: 5.4rem;

          .warrning_content {
            display: flex;
            justify-content: space-between;
            margin-top: 0.13rem;

            // height: 5.125rem;
            .warrning_content_item {
              width: 2.81rem;
              height: 4.65rem;
              // background: linear-gradient(154deg, #0b286a 0%, rgba(11, 40, 106, 0.19) 57%, #0b286a 100%);
              opacity: 0.94;

              .add_num {
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;

                img {
                  width: 0.94rem;
                  height: 1.01rem;
                  margin-top: 0.26rem;
                }

                span {
                  font-size: 0.45rem;
                  font-family: Impact-Regular, Impact;
                  font-weight: 400;
                  color: #fff200;
                  line-height: 0.33rem;
                  margin-top: 0.38rem;
                }

                label {
                  margin-top: 0.24rem;
                  font-size: 0.18rem;
                  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                  font-weight: 400;
                  color: #ffffff;
                  line-height: 0.18rem;
                }
              }

              .total_num {
                margin-top: 0.61rem;
                font-size: 0.18rem;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #ffffff;
                line-height: 0.2rem;
                padding-left: 0.25rem;
              }

              .type_num {
                display: flex;
                margin-top: 0.48rem;

                div {
                  flex: 1;
                  padding-left: 0.25rem;
                  display: flex;
                  flex-direction: column;

                  &:last-child {
                    padding-left: 0.45rem;

                    span {
                      color: #fff200;
                    }
                  }

                  span {
                    font-size: 0.18rem;
                    font-family: Impact-Regular, Impact;
                    font-weight: 400;
                    color: #ffffff;
                    line-height: 0.22rem;
                  }

                  label {
                    font-size: 0.15rem;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #ffffff;
                    line-height: 0.18rem;
                    opacity: 0.6;
                    margin-top: 0.1rem;
                  }
                }
              }
            }
          }

          .map-font {
            width: 100%;
            height: 0.7rem;
            // background-color: #fff200;
            padding: 0.3rem 0 0 0.3rem;
            box-sizing: border-box;
            display: flex;
            flex-wrap: wrap;

            .font-box {
              width: 2.0375rem;
              height: 0.3125rem;
              // background-color: #00e0db;
              display: flex;
              align-items: center;
              justify-content: space-evenly;
              font-size: 0.125rem;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #ffffff;
              position: relative;

              .radio {
                width: 8px;
                height: 8px;
                // background-color: red;
                border-radius: 50%;
                position: absolute;
                left: -0.05rem;
              }
            }

            .font-box:nth-child(2) {
              margin-left: 0.35rem;
            }

            // .font-box:nth-child(3) {
            //   margin-left: 0.35rem;
            // }
            // .font-box:nth-child(5) {
            //   margin-left: 0.35rem;
            // }
          }
        }

        .device {
          width: 5.75rem;
          height: 5.4rem;
          display: flex;
          flex-direction: column;
          background: linear-gradient(64deg, rgba(11, 40, 106, 0.62) 0%, rgba(11, 40, 106, 0.19) 57%, rgba(0, 22, 78, 0.62) 100%);
          padding: 0 0.125rem;

          .device_content {
            height: 4.5rem;
            display: flex;
            flex-wrap: wrap;
            width: 5.75rem;

            .device_item {
              width: 2.81rem;
              height: 2.31rem;
              opacity: 0.94;
              margin-top: 0.14rem;
              margin-right: 0.13rem;
              display: flex;
              align-items: center;
            }
          }
        }

        .service {
          margin-top: 0.36rem;
          height: 5.4rem;
          background: linear-gradient(154deg, rgba(11, 40, 106, 0.62) 0%, rgba(11, 40, 106, 0.19) 57%, rgba(11, 40, 106, 0.62) 100%);
          padding: 0 0.125rem;

          .service_content {
            width: 5.75rem;
            height: 4.65rem;
            opacity: 0.94;
            margin-top: 0.14rem;
            display: flex;
            flex-wrap: wrap;

            // padding-top: 0.45rem;
            .service_item {
              width: 50%;
              display: flex;
              padding-left: 0.45rem;

              img {
                width: 0.5rem;
                height: 0.5rem;
                margin-right: 0.28rem;
              }

              div {
                display: flex;
                flex-direction: column;

                label {
                  font-size: 0.18rem;
                  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                  font-weight: 500;
                  color: rgba(255, 255, 255, 0.6);
                }

                span {
                  margin-top: 0.19rem;
                  font-size: 0.25rem;
                  font-family: Impact-Regular, Impact;
                  font-weight: 400;
                  color: #fff200;
                  line-height: 0.25rem;
                }
              }
            }
          }
        }
      }

      .box-center {
        width: 11.98rem;
        // background: url('../../../../assets/yq/index_map_bg.png');
        background-size: 100% 100%;
        position: relative;

        .tips {
          width: 5.25rem;
          height: 1.5rem;
          // background-color: red;
          position: absolute;
          top: 0.35rem;
          right: 0.15rem;
          display: flex;
          flex-direction: column;

          .env {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 0.18rem;

            .env-text {
              height: 0.625rem;
              display: flex;
              align-items: center;
            }

            img {
              width: 0.7375rem;
              height: 0.55rem;
            }

            span {
              font-size: 0.375rem;
              font-family: Impact-Regular, Impact;
              font-weight: 400;
              color: #fff200;
            }

            label {
              font-size: 0.175rem;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #ffffff;
              margin: 0 0.175rem 0 0.275rem;
            }
          }
        }

        .map_main {
          width: 100%;
          height: 85%;
        }

        .source {
          width: 100%;
          height: 15%;
          display: flex;
          flex-direction: column;
          // justify-content: space-around;
          // align-items: center;

          .source_box {
            display: flex;
            height: 60%;
            margin-top: 10px;
          }

          .count {
            flex: 1;
            height: 80%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 0.33rem;
            font-family: Impact-Regular, Impact;
            font-weight: 400;
            color: #FFFFFF;

            span:nth-child(2) {
              color: #FFF200;
            }
          }

          .cow_sheep {
            flex: 1;
            height: 80%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 0.33rem;
            font-family: Impact-Regular, Impact;
            font-weight: 400;
            color: #FFFFFF;

            span:nth-child(2) {
              color: #FFF200;
            }
          }
        }
      }

      .center {
        width: 100%;
        flex: 1;
        // background-color: #FFFFFF;
        display: flex;
        flex-direction: column;
      }

      .num {
        width: 100%;
        height: 0.4375rem;
        // background-color: #00E0DB;
        margin-top: 0.325rem;
        padding-left: 0.175rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;

        .title {
          font-size: 0.175rem;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
        }

        .card {
          flex: 1;
          height: 100%;
          margin-left: 0.25rem;
          // background-color: olivedrab;
          display: flex;

          .card-num {
            width: 0.4375rem;
            height: 0.4375rem;
            background: linear-gradient(154deg, #0b286a 0%, rgba(11, 40, 106, 0.19) 57%, #0b286a 100%);
            font-size: 0.325rem;
            font-family: Impact-Regular, Impact;
            background: rgba(0, 254, 255, 0.12);
            box-shadow: inset 0px 0px 6px 0px rgba(0, 224, 219, 0.2);
            border-radius: 0px 0px 0px 0px;
            opacity: 1;
            border: 1px solid rgba(0, 254, 255, 0.102);
            font-weight: 400;
            color: #fff200;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 0.125rem;
          }

          .font {
            color: #fff200;
            font-size: 0.325rem;
            font-family: Impact-Regular, Impact;
            font-weight: 400;
            color: #fff200;
            display: flex;
            align-items: flex-end;
            margin-bottom: 0.125rem;
            margin-right: 0.125rem;
          }
        }
      }

      .pie {
        width: 100%;
        // flex: 1;
        height: 3rem;
        // background-color: cadetblue;
      }

      .map-font {
        width: 100%;
        height: 0.7rem;
        // background-color: #fff200;
        padding: 0.3rem 0 0 0.3rem;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;

        .font-box {
          width: 2.0375rem;
          height: 0.3125rem;
          // background-color: #00e0db;
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          font-size: 0.125rem;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
          position: relative;

          .radio {
            width: 8px;
            height: 8px;
            // background-color: red;
            border-radius: 50%;
            position: absolute;
            left: -0.05rem;
          }
        }

        .font-box:nth-child(2) {
          margin-left: 0.35rem;
        }

        // .font-box:nth-child(3) {
        //   margin-left: 0.35rem;
        // }
        // .font-box:nth-child(5) {
        //   margin-left: 0.35rem;
        // }
      }
    }
  }

  .fillWidth {
    width: 100%;
    height: 100%;
    object-fit: fill;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -99;
  }
}
</style>
